<template>
  <breadCrumbs title="Email Compose" main="Email" title1="Email Compose" />

  <div class="container-fluid">
    <div class="email-wrap">
      <div class="row">
        <sidePage />
        <div class="col-xl-9 col-md-12 xl-70 box-col-70">
          <div class="email-right-aside">
            <div class="card email-body">
              <div class="email-profile">
                <div class="email-body">
                  <div class="email-compose">
                    <div class="email-top compose-border">
                      <div class="compose-header">
                        <h4 class="mb-0">New Message</h4>
                        <button class="btn btn-primary" type="button"><i class="fa fa-file me-2"></i> save</button>
                      </div>
                    </div>
                    <div class="email-wrapper">
                      <form class="theme-form">
                        <div class="form-group">
                          <label class="col-form-label pt-0" for="exampleInputEmail1">To</label>
                          <input class="form-control" id="exampleInputEmail1" type="email">
                        </div>
                        <div class="form-group">
                          <label for="exampleInputPassword1">Subject</label>
                          <input class="form-control" id="exampleInputPassword1" type="text">
                        </div>
                        <div class="form-group">
                          <label>Message</label>
                          <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>

                        </div>
                        <DropZone class="text-center" :maxFileSize="Number(60000000)" url="http://localhost:8080"
                          :uploadOnDrop="true" :multipleUpload="true" :parallelUpload="2" />
                      </form>
                      <div class="action-wrapper mt-3">
                        <ul class="actions">
                          <li><router-link class="btn btn-secondary" to="/email/readMail"><i
                                class="fa fa-paper-plane me-2"></i>send</router-link></li>
                          <li><router-link class="btn btn-danger" to="/dashboard/default"><i
                                class="fa fa-times me-2"></i>cancel</router-link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


import sidePage from '../sidePage.vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
  name: 'composeView',
  components: {
    sidePage,
    ckeditor: CKEditor.component
  },
  data() {
    return {
      type: 'inbox',
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        config: { height: '300px' }
      },
      menutoogle: false,
    };
  },
}
</script>